import { useEffect, useState } from 'react';
import {
  fetchWorkingCalendar,
  type WorkingCalendarDayOffs,
} from '../../../../api/workingCalendarApis';
import { getCustomerId } from '../../../../utils/cookies';

/**
 * Load project working calendar (week-offs + holidays) for Day-scale Look ahead blocking.
 */
export function useProjectWorkingCalendar(opts: {
  projectId: string;
  enabled: boolean;
}): {
  dayOffs: WorkingCalendarDayOffs | null;
  loading: boolean;
} {
  const { projectId, enabled } = opts;
  const [dayOffs, setDayOffs] = useState<WorkingCalendarDayOffs | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled || !projectId) {
      setDayOffs(null);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    void fetchWorkingCalendar({
      customerId: getCustomerId(),
      projectId,
    })
      .then((result) => {
        if (cancelled) return;
        setDayOffs(result);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, projectId]);

  return { dayOffs, loading };
}
